import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Hoja from "../../../images/modulo14/hoja.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad1Actividad7.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[8];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[0].name}: ${modulo14.content[0].activities[9].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[9].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[7].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[7].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Continúa trabajando con tu compañero, compañera o familiar.{" "}
            </li>
            <li>
              Lean las dos razones por las que sería importante que José hablara
              aimara y castellano.
            </li>
          </ul>
          <div className="row align-items-center my-5 px-4">
            <div className="col-lg-8 col-12">
              <img src={Hoja} className="bg-white img-fluid" alt="Hoja" />
            </div>
          </div>

          <ul>
            <li>
              Escojan una de las razones y conversen entre ustedes: ¿por qué les
              parece una buena razón para que José sea bilingüe?
            </li>
          </ul>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea las dos primeras indicaciones: Continúa trabajando con tu
            compañero o compañera. Lean las dos razones por las que sería
            importante que José hablara aimara y castellano. Pida a un niño y
            una niña que lean en voz alta las razones que se presentan.
          </li>
          <li>
            Lea la siguiente indicación y dé un tiempo para que trabajen: Escojan una de las razones y conversen entre ustedes: ¿por
            qué les parece una buena razón para que José sea bilingüe? Retome
            las respuestas. Pueden escoger cualquiera de las
            dos razones, lo importante es que expliquen el porqué de su
            elección. Para ello, pueden usar ejemplos. En la razón 1, pueden
            usar ejemplos de las distintas situaciones en las que José se podría
            desenvolver en aimara y mencionar otras situaciones para el
            castellano. En la razón 2, pueden usar ejemplos de las personas con
            las que podría hablar aimara y los contextos donde podría hacerlo, y
            lo mismo para el castellano.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
